"use client";

import { Link } from "@chakra-ui/next-js";

const PostLink = ({ title, href }: { title: string; href: string }) => {
  return (
    <Link
      href={href}
      _hover={{
        textDecoration: "none",
        color: "brand.primary",
      }}
    >
      {title}
    </Link>
  );
};

export default PostLink;
